import CONSTANTS from '../constants'
import { getRequest ,downloadFile,postRequest,putRequest, downloadPdfFile} from '../../services'
// import { APICONFIG } from '../apiConfig'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'


// GET Price BY Time
export const getPriceDetailsByTime = (facility,slug) => (dispatch) => {
    const payload = {
        facility : facility,
        slug : slug
    }
    dispatch(addEventLog(payload, CONSTANTS.GET_RESERVATION_PRICE_REQUEST))
    dispatch({ type: CONSTANTS.GET_RESERVATION_PRICE_REQUEST })
    return getRequest(`${APICONFIG.getPriceByTime}/${facility}?${slug}`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_RESERVATION_PRICE_SUCCESS))
        dispatch({ type: CONSTANTS.GET_RESERVATION_PRICE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_RESERVATION_PRICE_FAILURE))
        
        dispatch({ type: CONSTANTS.GET_RESERVATION_PRICE_FAILURE, errorMessage: err })
        return err
    })
}

// GET Price BY Time
export const applyPromoCodeReservation = (payload) => (dispatch) => {
   // console.log('payload',payload)
    
    dispatch(addEventLog(payload, CONSTANTS.GET_RESERVATION_PROMO_CODE_REQUEST))
    dispatch({ type: CONSTANTS.GET_RESERVATION_PROMO_CODE_REQUEST })
    return postRequest(APICONFIG.applyPromoCode, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_RESERVATION_PROMO_CODE_SUCCESS))
        dispatch({ type: CONSTANTS.GET_RESERVATION_PROMO_CODE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_RESERVATION_PROMO_CODE_FAILURE))
        
        dispatch({ type: CONSTANTS.GET_RESERVATION_PROMO_CODE_FAILURE, errorMessage: err })
        return err
    })
}

export const saveReservationPayment = (payload) => (dispatch) => {
    //console.log('payment payload',payload)
    dispatch(addEventLog(payload, CONSTANTS.SAVE_RESERVATION_REQUEST))
    dispatch({ type: CONSTANTS.SAVE_RESERVATION_REQUEST })
    return postRequest(APICONFIG.saveReservationPaymentUrl, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.SAVE_RESERVATION_SUCCESS))
        dispatch({ type: CONSTANTS.SAVE_RESERVATION_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.SAVE_RESERVATION_FAILURE))
        dispatch({ type: CONSTANTS.SAVE_RESERVATION_FAILURE, errorMessage: err })
        return err
    })
}

export const updateReservationPayment = (payload) => (dispatch) => {
    //console.log('payment payload',payload)
    dispatch(addEventLog(payload, CONSTANTS.SAVE_RESERVATION_REQUEST))
    dispatch({ type: CONSTANTS.SAVE_RESERVATION_REQUEST })
    return putRequest(APICONFIG.updateReservationURL, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.SAVE_RESERVATION_SUCCESS))
        dispatch({ type: CONSTANTS.SAVE_RESERVATION_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.SAVE_RESERVATION_FAILURE))
        dispatch({ type: CONSTANTS.SAVE_RESERVATION_FAILURE, errorMessage: err })
        return err
    })
}

// GET PARTNER BY SLUG
export const getPartnerDetailsBySLug = (slug) => (dispatch) => {
    const payload = {
        slug : slug
    }
    dispatch(addEventLog(payload, CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST))
    dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST })
    return getRequest(`${APICONFIG.getPartnerBySlug}/${slug}`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS))
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE))
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE, errorMessage: err })
        return err
    })
}



export const downloadTicket = (payload,ticketNumber, isEvent= false) => (dispatch) => {
    const payloadLog = {
        payload : payload,
        ticketNumber: ticketNumber
    }
    dispatch(addEventLog(payloadLog, CONSTANTS.DOWNLOAD_TICKET_REQUEST))
    dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_REQUEST })
    return downloadFile(`${isEvent ? APICONFIG.downloadQrcodeRequestUrl : APICONFIG.downloadBookingEticketUrl}/${payload}`, payload, `${ticketNumber ? ticketNumber : 'ticket'}.pdf`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.DOWNLOAD_TICKET_SUCCESS))
        dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.DOWNLOAD_TICKET_FAILURE))
        dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_FAILURE })
        return err
    })
}

export const downloadPassTicket = (postData, pdfName, setLoaderTicket) => () => {
    let endpoint = `${APICONFIG.downloadPassQrcodeRequestUrl}/${postData}`
    return downloadPdfFile(endpoint, `${pdfName}.pdf`, setLoaderTicket)
}

// GET gate controll
export const getCheckInGate = (facility) => (dispatch) => {
    const payload = {
        facility : facility
    }
    dispatch(addEventLog(payload, CONSTANTS.GET_CRUISE_LINE_REQUEST))
    dispatch({ type: CONSTANTS.GET_CRUISE_LINE_REQUEST })
    return getRequest(`${APICONFIG.getCheckInGateUrl}/${facility}`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_CRUISE_LINE_SUCCESS))
        dispatch({ type: CONSTANTS.GET_CRUISE_LINE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_CRUISE_LINE_FAILURE))
        dispatch({ type: CONSTANTS.GET_CRUISE_LINE_FAILURE, errorMessage: err })
        return err
    })
}

export const inventoryUpdateReservatino = (payload) => (dispatch) => {
    //console.log('payment payload',payload)
    dispatch(addEventLog(payload, CONSTANTS.INVENTORY_UPDATE_REQUEST))
    dispatch({ type: CONSTANTS.INVENTORY_UPDATE_REQUEST })
    return postRequest(APICONFIG.inventoryUpdatereservation, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.INVENTORY_UPDATE_SUCCESS))
        dispatch({ type: CONSTANTS.INVENTORY_UPDATE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.INVENTORY_UPDATE_FAILURE))
        dispatch({ type: CONSTANTS.INVENTORY_UPDATE_FAILURE, errorMessage: err })
        return err
    })
}